import { client } from "../amplifyClient";
import { SEARCH_TOKENS_QUERY } from "../../components/graphql/searchTokens.queries";

export async function searchTokens({
  collectionName,
  word,
  objectType,
  limit = 25,
  nextToken,
}) {
  const variables = { collectionName, word, objectType, limit, nextToken };
  console.log("[searchTokens] query →", variables);
  try {
    const res = await client.graphql({ query: SEARCH_TOKENS_QUERY, variables });
    const result = res.data.searchTokens ?? { items: [], nextToken: null };
    console.log("[searchTokens] response →", result);
    return result;
  } catch (err) {
    console.error("[searchTokens] error →", err);
    throw err;
  }
}
